<template>
  <modal ref='modal'>
    <template #header>
      <h5 class="modal-title mt-0">
        {{ $t('record_show.bulk_extract_text_from_pdf', { n: recordIds.length }) }}
      </h5>
    </template>

    <template #body>
      <form @submit.prevent='submit()'>
        <div class='modal-body extract-modal'>
          <p>{{$t('record_show.you_can')}}</p>
          <ul>
            <li>{{$t('record_show.search')}}</li>
            <li>{{$t('record_show.extract')}}</li>
            <li>{{$t('record_show.find')}}</li>
          </ul>
          <p>{{$t('record_show.note')}}</p>
          <strong>
            {{$t('record_show.file_count')}} {{ `${ocrFileCurrent} / ${ocrFileLimit}` }} {{ $t('record_show.processed') }}
          </strong>
        </div>

        <div class="modal-footer" v-if="ocrLimitReached">
          <p class="benefits-ocr">{{ $t('record_show.file_limit') }}
            <a href="mailto:christian.alsen@relatico.com">christian.alsen@relatico.com</a>
          </p>
        </div>

        <div class="modal-footer" v-else>
          <input @click.prevent='$refs.modal.close()' type='submit' :value="$t('folder_show.modals.delete.cancel')" class="btn btn-neutral">
          <input type='submit' :value="$t('record_show.button_extract_text')" class='btn btn-primary' />
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
  import _modal from '../_modal'

  export default {
    components: {
      modal: _modal,
    },
    data() {
      return {
        recordIds: [],
      }
    },
    computed: {
      ocrInfo() {
        return this.state.ocrInfo || {}
      },
      ocrFileLimit() {
        return this.ocrInfo.ocr_limit
      },
      isOcrEnabled() {
        return this.ocrFileLimit > 0
      },
      ocrFileCurrent() {
        return this.ocrInfo.ocr_current
      },
      ocrLimitReached() {
        return this.ocrFileCurrent == this.ocrFileLimit
      },
    },
    methods: {
      open(records) {
        this.recordIds = records.filter(r => r.ocr_in_progress ? false : !r.ocr_content)
        this.recordIds = this.recordIds.slice(0, this.ocrFileLimit - this.ocrFileCurrent).map(r => r.id)

        this.$refs.modal.open()
      },
      submit() {
        const promises = this.recordIds.map(id => this.store.createRecordOcr(id))

        Promise.allSettled(promises).then(() => {
          this.store.getCurrentUser()
          this.store.sendMetrics({name: 'bulk_create_orc_from_file', params: this.$route.params, path: this.$route.fullPath})
          this.$emit('success')
          this.$toastr.success(this.$t('record.updated'))
          this.$refs.modal.close()
        })
      },
    }
  }
</script>
